import React, { useContext } from "react";
import { IconButton, ListActionButtonProps, Stack } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderRequestListingContext } from "../context/OrderRequestListingContext";
import { OrderRequestListingItem } from "../OrderRequestListingItem";

type PinOrderListingButtonProps = ListActionButtonProps<OrderRequestListingItem>;

export const PinOrderRequestListingButton: React.VFC<PinOrderListingButtonProps> = ({
    item
}: PinOrderListingButtonProps) => {
    const { togglePinnedOrderRequest } = useContext(OrderRequestListingContext);

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <Stack horizontal verticalAlign="center">
                <IconButton
                    iconProps={{ iconName: item.isPinned ? "PinnedSolid" : "Pinned" }}
                    styles={{
                        iconButton: {
                            flexContainer: { alignItems: "flex-start" }
                        }
                    }}
                    tooltipContent={`${item.isPinned ? "Unpin" : "Pin"} order`}
                    testId="pin-list-button"
                    onClick={() => togglePinnedOrderRequest(item.id)}
                />
            </Stack>
        </AuthorizationWrapper>
    );
};
